<template>
  <div>
    <Checkbox v-model="fieldValue" :binary="true" :disabled="disabled"></Checkbox>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

export default {
  name: "DynamicCheckbox",
  props: ['uniqueId', 'disabled'],
  data() {
    return {}
  },
  computed: {
    ...mapGetters('search', [
      'getData'
    ]),
    fieldValue: {
      get() {
        return this.getData(this.uniqueId)[0] === 'true';
      },
      set(data) {
        this.setData({uniqueId: this.uniqueId, data: [data + '']})
      }
    },
  },
  methods: {
    ...mapActions('search', [
      'setData'
    ]),

  },
}
</script>

<style scoped>

</style>